import { render } from "./Psc.vue?vue&type=template&id=702fa7e8&scoped=true&ts=true"
import script from "./Psc.ts?vue&type=script&lang=ts"
export * from "./Psc.ts?vue&type=script&lang=ts"

import "./Psc.scss?vue&type=style&index=0&id=702fa7e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702fa7e8"]])

export default __exports__